<template>
  <BaseButtonRectangle class="base-button-login-facebook">
    <transition name="fade" mode="out-in">
      <BaseText6 class="text" text="Continue with Facebook" v-if="!loading"/>
      <BaseLoaderCircle class="loader" v-else/>
    </transition>
  </BaseButtonRectangle>
</template>

<script>
import BaseButtonRectangle from '@/components/BaseButtonRectangle/BaseButtonRectangle'
import BaseLoaderCircle from '@/components/BaseLoaderCircle/BaseLoaderCircle'
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  components: {
    BaseButtonRectangle,
    BaseLoaderCircle,
    BaseText6
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button-login-facebook {
  background: #507CC0;
  border: none !important;
  position: relative;
}
.text {
  margin: 0 auto;
  position: relative;
  &::before {
    position: absolute;
    height: 0.95rem;
    width: 1rem;
    top: 40%;
    right: calc(100% + 1rem);
    transform: translateY(-50%);
    background-image: url('../../assets/img/facebook.svg');
    background-size: auto 100%;
    background-position: center center;
    background-repeat: no-repeat;
    content: '';
  }
}
.loader {
  height: 40%;
}
</style>
